var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from '@mui/material';
import { useInfoDialogStore } from '../store/infoDialog';
export var InfoDialog = function () {
    var _a = useInfoDialogStore(), show = _a.show, content = _a.content, setShow = _a.setShow;
    return (_jsxs(Dialog, __assign({ open: show, onClose: function () { return setShow(false); } }, { children: [_jsx(DialogTitle, { children: "Info" }), _jsx(DialogContent, { children: content }), _jsx(DialogActions, { children: _jsx(Button, __assign({ variant: "outlined", onClick: function () { return setShow(false); } }, { children: "Close" })) })] })));
};
export var InfoLink = function (_a) {
    var content = _a.content, children = _a.children;
    var _b = useInfoDialogStore(), setShow = _b.setShow, setContent = _b.setContent;
    return (_jsx("span", __assign({ style: { cursor: 'pointer' }, onClick: function () {
            setShow(true);
            setContent(content);
        } }, { children: children })));
};
